export const Color = {
  danger: '#d5233f',
  info: '#eba828',
  white: '#ffffff',
  black: '#000000',
  primary: '#0052a5',
  primaryLight: '#006cd7',
  secondary: '#006cd7',
  secondaryDark: '#a7162d',
  lightBlack: '#1b1b1b',
  darkGray: '#656565',
  gray: '#767676',
  lightGray: '#b7b7b7',
  lighterGray: '#f1f1f1',
  veryLightGrey: '#cbcbcb',
  green: '#598527',
  watermark: '#605E5E'
};
